import { Megaphone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ListSkeleton } from '@/components/ui/skeleton';
import { useAnnouncementStore } from '../store';
import { AnnouncementCard } from './AnnouncementCard';

export function AnnouncementsList() {
  // AppLayout owns the initial fetch on app load. We deliberately do NOT re-fetch
  // here on empty result — that creates an infinite loop because an empty array
  // satisfies `length === 0` after every fetch.
  const activeAnnouncements = useAnnouncementStore((s) => s.activeAnnouncements);
  const isLoadingActive = useAnnouncementStore((s) => s.isLoadingActive);
  const activeError = useAnnouncementStore((s) => s.activeError);
  const fetchActive = useAnnouncementStore((s) => s.fetchActive);

  if (isLoadingActive && activeAnnouncements.length === 0) {
    return <ListSkeleton rows={4} />;
  }

  if (activeError) {
    return (
      <div className="flex flex-col items-start gap-3 rounded-lg border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive">
        <p>{activeError}</p>
        <Button variant="outline" size="sm" onClick={() => fetchActive()}>
          Try again
        </Button>
      </div>
    );
  }

  if (activeAnnouncements.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center rounded-lg border bg-muted/10 py-16 text-center">
        <Megaphone className="mb-3 h-10 w-10 text-muted-foreground" />
        <h3 className="text-base font-medium">No announcements right now</h3>
        <p className="mt-1 max-w-sm text-sm text-muted-foreground">
          When the team posts new updates, they'll appear here.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {activeAnnouncements.map((a) => (
        <AnnouncementCard key={a.id} announcement={a} />
      ))}
    </div>
  );
}
